
var jQuery = require("jquery");
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

$(document).on("turbolinks:load", function() {

  var table = $('.data-table').dataTable( {
    "dom": 'lrtip',
    "autoWidth": false,
    "order": [[1, "asc"]],
    stateSave: true,
    language: {
      'paginate': {
        'previous': '&#8592;',
        'next': '&#8594;'
      },
      'info': "_END_" + $('.data-table').data('of') + "_TOTAL_" + $('.data-table').data('entries'),
    }
  } );

  var emptyTable = $('.empty-data-table').dataTable( {
    "dom": 'lrtip',
    "autoWidth": false,
    "info": false,
    "paging": false,
  } );

  $(".input-search").on("keyup change search", function() { 
    table.api().search( this.value ).draw();
    $(".input-search").val(this.value);
  });
  
});

//Avoid duplicate data table when using back browser button

$(document).on('turbolinks:before-cache', function() {
  dataTable =  $($.fn.dataTable.tables(false)).DataTable()
  if (dataTable != null)
  {
   dataTable.destroy();
   dataTable = null;    
  }
});